module.exports = __webpack_public_path__ + "static/media/IMG_20191128_144701.046a2fd4.jpg";